import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

/** A collection nested under a section in the outline (its own indent + dashed rule). */
export const OutlineCollection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.125rem;
  margin-left: 0.5rem;
  padding-left: 0.625rem;
  border-left: 1px dashed var(--neutral-200, #c3ccd5);
`

/** Separates consecutive review cards on the canvas — mirrors StepDivider in the recipient view. Uses
 * padding rather than margin (padding never collapses, unlike a flex item's first-child margin). Canvas
 * already puts a 1rem row-gap above this div (between it and the previous card) with nothing equivalent
 * below, so the two paddings are deliberately uneven to end up visually centred rather than matching numbers. */
export const CardDivider = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 1.5rem;

  &::before {
    content: '';
    display: block;
    border-top: 1px dashed var(--neutral-200, #c3ccd5);
  }
`

export const CanvasCardDescription = styled.div`
  ${font('sm', 'regular')}
  color: var(--colour-text-secondary, #607890);
`

export const CardActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 1.5rem 0 0.5rem;
`

/** Bottom of a section block: Add actions on the left, Edit link on the right, one row. */
export const SectionFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.875rem;
`

export const SectionsList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  margin: 0.75rem 0 0;
`

export const SectionBlock = styled.div`
  border: 1px solid var(--neutral-100, #e5e9ed);
  border-radius: 0.5rem;
  padding: 0.875rem 1rem;
  background-color: #e9edf2;
`

export const SectionBlockHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 0.5rem;
`

export const SectionBlockTitle = styled.div`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
`

export const SectionBlockDescription = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  margin-top: 0.25rem;
`

export const SectionTypeNote = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #8c99a8);
  margin-top: 0.5rem;
`

/** Caption above a factory section's preview explaining the fields are component-generated. */
export const FactorySectionCaption = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #8c99a8);
  margin-top: 0.5rem;
`

/** Flags a section whose type doesn't apply to the form's family (e.g. a tenant-signature section type
 * left over on a Notice) — informational only, doesn't block anything. */
export const SectionFamilyMismatchNote = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-warning, #a15c00);
  margin-top: 0.25rem;
`

export const NoSectionsNote = styled.div`
  ${font('sm', 'regular')}
  color: var(--colour-text-secondary, #607890);
  margin: 0.5rem 0;
`
